import { Popup } from "./popup";
import { windowWidth } from "./utils";

const mobMenu = {
  nextLevel: document.querySelectorAll(".jsNextLevel") as NodeListOf<HTMLElement>,
  prevLevel: document.querySelectorAll(".jsPrevLevel") as NodeListOf<HTMLElement>,
  close: document.getElementById('jsCloseMenu') as HTMLElement,


  init() {


 
    this.setNextLevel()
    this.setPrevLevel()
      const menu = new Popup("#jsMenuWrap", "#jsOpenMenu", "#jsCloseMenu");
      menu.init();

      const cart = new Popup('#jsCartWrap', '#jsOpenCart', '#jsCloseCart');
      cart.init();

      const search = new Popup('#jsSearchWrap', '#jsOpenSearch', '#jsCloseSearchbar'); 
      search.init();
      
      const account = new Popup('#jsUserWrap', '#jsOpenUser', '#jsCloseUser'); 
      account.init();

      const filterPopup = new Popup("#jsFilterWrap", "#jsOpenFilters", "#jsCloseFilter");
      filterPopup.init();

      const finder = new Popup('#jsFinderWrap', '#jsOpenFinder', '#jsCloseFinder');
      finder.init();


    const mobFinder = new Popup('#jsFinderWrap', '#jsOpenMobFinder', '#jsCloseFinder');
    mobFinder.init();

  },  






  setNextLevel() {
    this.nextLevel.forEach((item) => {
      const subMenu = item.nextElementSibling as HTMLElement
      if (subMenu) {
        item.addEventListener("click", (e) => {
          e.preventDefault()          
          subMenu.classList.add("activeClass")        
        })
      }

      this.close.addEventListener('click', (e) => {
        subMenu.classList.remove("activeClass")  
      });
    })
  },


  setPrevLevel() {
    this.prevLevel.forEach((item) => {
      const menu = item.parentElement?.parentElement as HTMLElement
      if (menu) {
        item.addEventListener("click", () => {                  
          menu?.classList.remove("activeClass")        
        })
      }
      this.close.addEventListener('click', (e) => {
        menu?.classList.remove("activeClass")  
      });
    })
  },


}

export default mobMenu
